import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { reviews } from "@/mocks/reviews";
import { articles } from "@/mocks/articles";

export default function AboutPage() {
  return (
    <>
      <Navbar />

      {/* Schema.org AboutPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于我们 - 51黑料网",
            url: "http://afvhue.cn/about",
            mainEntity: {
              "@type": "Organization",
              name: "51黑料网",
              description:
                "专注社会热点、娱乐八卦、科技资讯的真实爆料第一平台",
              foundingDate: "2020",
              url: "http://afvhue.cn/",
            },
          }),
        }}
      />

      <main>
        {/* About - 品牌介绍 */}
        <section className="bg-background-50 pt-24 pb-12 md:pb-16">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            {/* Visual */}
            <div className="rounded-2xl overflow-hidden mb-12">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20journalism%20office%20with%20warm%20golden%20lighting%2C%20professional%20newsroom%20atmosphere%2C%20artistic%20blur%20background%2C%20modern%20media%20company%20aesthetic%2C%20clean%20composition%2C%20soft%20atmospheric%20glow%2C%20sophisticated%20warm%20tones&width=1200&height=500&seq=about-hero-2026&orientation=landscape"
                alt="51黑料网品牌介绍"
                title="51黑料网 - 品牌介绍"
                className="w-full aspect-[12/5] object-cover"
              />
            </div>

            {/* Label */}
            <div className="flex justify-center mb-6">
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-information-line text-xs"></i>
                </span>
                品牌介绍
              </span>
            </div>

            {/* Title */}
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center">
              关于<span className="text-accent-600">51黑料网</span>
            </h1>

            {/* Content */}
            <div className="mt-8 space-y-5">
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                51黑料网成立于2020年，是国内领先的真实爆料资讯平台。我们致力于为读者提供真实、及时、深度的独家爆料内容，涵盖<strong>社会热点</strong>、<strong>娱乐八卦</strong>和<strong>科技资讯</strong>三大核心板块。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                在这个信息爆炸的时代，真实反而成为最稀缺的资源。51黑料网坚持「<strong>真实第一</strong>」的原则，每一篇爆料都经过多方信源交叉验证，确保读者获取的是经得起推敲的独家内幕，而非捕风捉影的谣言。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                我们的编辑团队由资深媒体人和行业专家组成，遍布全国主要城市的信息网络能够第一时间捕捉到热点事件的蛛丝马迹。从社会民生的深度调查，到娱乐圈的独家内幕，再到科技行业的前沿动态——51黑料网始终走在信息的最前沿。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                截至2026年，51黑料网已拥有超过<strong>500万</strong>月活跃用户，累计发布独家爆料<strong>{articles.length}+篇</strong>。我们相信，真实的力量可以改变世界，而51黑料网，正是这份力量的传播者。
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
              <div className="text-center p-4 rounded-xl bg-accent-100/70">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">5M+</p>
                <p className="text-xs text-accent-700 mt-1">月活跃用户</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-primary-100/70">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">14+</p>
                <p className="text-xs text-primary-700 mt-1">独家爆料</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-secondary-100/70">
                <p className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">3</p>
                <p className="text-xs text-secondary-700 mt-1">核心板块</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-accent-100/70">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">24h</p>
                <p className="text-xs text-accent-700 mt-1">实时更新</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial Review - 口碑评价 */}
        <section className="bg-background-100/50 py-16 md:py-20">
          <div className="px-4 md:px-6 max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 mb-5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-line text-accent-600 text-xs"></i>
                </span>
                <span className="text-xs font-medium text-accent-700 tracking-wide">口碑评价</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                用户<span className="text-accent-600">口碑</span>
              </h2>
              <p className="mt-3 text-foreground-500 text-sm md:text-base">
                听听大家对51黑料网的真实评价
              </p>
            </div>

            {/* Reviews grid - 3 cols, 2 rows, 5 cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Row 1: Two text cards + one photo card */}
              {reviews.slice(0, 2).map((review) => (
                <div
                  key={review.id}
                  className="bg-secondary-50/80 rounded-2xl p-6 flex flex-col justify-between"
                >
                  <div>
                    <span className="w-8 h-8 flex items-center justify-center mb-4">
                      <i className="ri-double-quotes-l text-2xl text-secondary-300"></i>
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {review.content}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-6 pt-4 border-t border-secondary-200/60">
                    <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}

              {/* Photo card */}
              <div className="bg-background-50 rounded-2xl overflow-hidden relative h-full min-h-[280px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20media%20team%20in%20modern%20newsroom%2C%20collaborative%20atmosphere%2C%20warm%20golden%20lighting%2C%20editorial%20style%20photography%2C%20diverse%20team%20working%20together%2C%20clean%20professional%20composition%2C%20soft%20depth%20of%20field&width=600&height=800&seq=about-review-photo-2026&orientation=portrait"
                  alt="51黑料网团队"
                  title="51黑料网 - 专业团队"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent p-6">
                  <p className="text-white font-semibold text-sm">专业团队</p>
                  <p className="text-white/70 text-xs mt-1">资深媒体人组成的编辑团队</p>
                </div>
              </div>
            </div>

            {/* Row 2: Wide card + two stacked */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              <div className="md:col-span-2 bg-background-50 rounded-2xl overflow-hidden relative h-64 md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20Chinese%20journalists%20and%20editors%20in%20modern%20creative%20workspace%2C%20brainstorming%20session%2C%20warm%20natural%20light%2C%20collaborative%20energy%2C%20editorial%20documentary%20style%2C%20clean%20composition%2C%20professional%20atmosphere&width=800&height=400&seq=about-team-wide-2026&orientation=landscape"
                  alt="51黑料网编辑团队"
                  title="51黑料网 - 编辑团队"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-transparent p-6">
                  <p className="text-white text-sm font-heading font-semibold">
                    「我们的使命是让每一个值得被听到的声音都能被世界听到。」
                  </p>
                  <p className="text-white/80 text-xs mt-2">— 51黑料网编辑团队</p>
                </div>
              </div>

              <div className="flex flex-col gap-6">
                {reviews.slice(3, 5).map((review) => (
                  <div
                    key={review.id}
                    className="bg-secondary-50/80 rounded-2xl p-5 flex-1 flex flex-col justify-between"
                  >
                    <div>
                      <span className="w-7 h-7 flex items-center justify-center mb-3">
                        <i className="ri-double-quotes-l text-xl text-secondary-300"></i>
                      </span>
                      <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3">
                        {review.content}
                      </p>
                    </div>
                    <div className="flex items-center gap-3 mt-4 pt-3 border-t border-secondary-200/60">
                      <div className="w-8 h-8 rounded-full overflow-hidden shrink-0">
                        <img
                          src={review.avatar}
                          alt={review.name}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-foreground-900">{review.name}</p>
                        <p className="text-xs text-foreground-400">{review.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section - 联系方式 */}
        <section className="bg-background-50 py-16 md:py-20">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            {/* Visual area */}
            <div className="rounded-2xl overflow-hidden mb-12">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20communication%20and%20connection%20concept%20with%20warm%20golden%20light%20rays%2C%20overlapping%20geometric%20shapes%2C%20professional%20business%20aesthetic%2C%20clean%20modern%20design%2C%20soft%20film%20grain%20texture%2C%20sophisticated%20warm%20atmosphere&width=1200&height=400&seq=about-contact-2026&orientation=landscape"
                alt="联系我们"
                title="51黑料网 - 联系我们"
                className="w-full aspect-[3/1] object-cover"
                loading="lazy"
              />
            </div>

            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 mb-5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-accent-600 text-xs"></i>
                </span>
                <span className="text-xs font-medium text-accent-700 tracking-wide">联系我们</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                商务合作 · <span className="text-primary-600 italic">投稿报料</span>
              </h2>
              <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                如果你有独家爆料线索，或者希望与51黑料网开展商务合作，欢迎通过以下方式联系
              </p>
            </div>

            {/* Contact form */}
            <div className="max-w-xl mx-auto">
              <form
                className="space-y-5"
                action="https://readdy.ai/api/form/d915g3q181e9e92u99eg"
                method="POST"
                data-readdy-form
              >
                {/* Honeypot */}
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="website-alt-field"
                />

                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-2">
                    您的姓名
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-2">
                    电子邮箱
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-2">
                    主题
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-3 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-400 transition-colors cursor-pointer"
                  >
                    <option value="">请选择主题</option>
                    <option value="投稿爆料">投稿爆料</option>
                    <option value="商务合作">商务合作</option>
                    <option value="媒体采访">媒体采访</option>
                    <option value="侵权投诉">侵权投诉</option>
                    <option value="其他">其他</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-2">
                    留言内容
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容（500字以内）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                </div>

                <button
                  type="submit"
                  className="w-full px-8 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
            </div>

            {/* Alternative contacts */}
            <div className="max-w-xl mx-auto mt-12 pt-8 border-t border-background-200">
              <p className="text-center text-sm text-foreground-500 mb-6">其他联系方式</p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="text-center p-4 rounded-xl bg-secondary-50/80">
                  <span className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-mail-open-line text-xl text-secondary-600"></i>
                  </span>
                  <p className="text-xs font-medium text-foreground-800">投稿邮箱</p>
                  <p className="text-xs text-foreground-400 mt-1">tips@afvhue.cn</p>
                </div>
                <div className="text-center p-4 rounded-xl bg-secondary-50/80">
                  <span className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-wechat-line text-xl text-secondary-600"></i>
                  </span>
                  <p className="text-xs font-medium text-foreground-800">微信公众号</p>
                  <p className="text-xs text-foreground-400 mt-1">51黑料网</p>
                </div>
                <div className="text-center p-4 rounded-xl bg-secondary-50/80">
                  <span className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-phone-line text-xl text-secondary-600"></i>
                  </span>
                  <p className="text-xs font-medium text-foreground-800">商务热线</p>
                  <p className="text-xs text-foreground-400 mt-1">400-888-5100</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
